import { isNonEmpty } from '@sgme/fp';
import classNames from 'classnames';
import { WithErrorTooltip } from 'components/shared/WithErrorTooltip/WithErrorTooltip';
import type { IntlKey } from 'locales';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { ApiError } from 'utils/http/apiErrorHelper';

import type { WithErrorTooltipPosition } from './WithTechnicalErrorTooltip';
import { WithTechnicalErrorTooltip } from './WithTechnicalErrorTooltip';

export type PriceImprovementRequestErrorType =
  | 'creation'
  | 'cancellation'
  | 'validation'
  | 'rejection'
  | 'acknowledgement';

interface ErrorFeedbackProps {
  className?: string;
  errorType: PriceImprovementRequestErrorType;
  error: ApiError;
  position?: WithErrorTooltipPosition;
  onDimiss: () => void;
}

export const ErrorFeedback: FC<ErrorFeedbackProps> = ({
  errorType,
  error,
  className,
  position = 'bottom',
  onDimiss,
}) => {
  const { formatMessage } = useIntl();

  const titleKey = useMemo<IntlKey>(() => `priceImprovement.error.${errorType}`, [errorType]);

  return (
    <div className={classNames('d-flex justify-content-center align-items-center text-danger', className)}>
      {isNonEmpty(error.workflowErrors) ? (
        <WithErrorTooltip
          errors={error.workflowErrors}
          errorTitle={titleKey}
          position={position}
          canCopy={false}
          onDismiss={onDimiss}
        >
          <em className="icon me-2">report_problem</em>
          {formatMessage({ id: titleKey })}
        </WithErrorTooltip>
      ) : (
        <WithTechnicalErrorTooltip
          error={error}
          title={titleKey}
          position={position}
          canCopy={false}
          onDismiss={onDimiss}
        >
          <em className="icon me-2">report_problem</em>
          {formatMessage({ id: titleKey })}
        </WithTechnicalErrorTooltip>
      )}
    </div>
  );
};
